import MediaQueries from "./_mediaQueries";

const _scrollTo = (() => {

    const scroll = (to: string | undefined) => {
        if(!to || to === "#") return;

        const toEl =  document.querySelector<HTMLElement>(to);
        const header = document.querySelector("header");
        
        if (toEl) {
            const scrollDestination = (toEl.offsetTop ?? 0 - (header?.clientHeight ?? 0));
            window.scroll({
                top: scrollDestination,
                behavior: MediaQueries.reduceMotion ?  "instant" : "smooth",
            });
        }
    };

    const pushHistory = (title: string, link: string | undefined) => {
        // Questo metodo triggera l'evento popstate
        // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
        try {
            window.history.pushState(null, title, link);
        }
        catch (err) { }
    };

    const init = () => {
        const header = document.querySelector("header");
        document.querySelectorAll('[href^=\'#\'],[data-scrollto]')
            .forEach(el => {
                if(header?.contains(el)) return;

                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    const $this = e.currentTarget as Element;
                    if ($this.attributes.getNamedItem("data-scrollto-nostate") !== undefined) {
                        scroll($this.attributes.getNamedItem('href')?.value);
                        return;
                    }
                    pushHistory($this.innerHTML, $this.attributes.getNamedItem('href')?.value);
                    scroll($this.attributes.getNamedItem('href')?.value);
                });
        });
        try {
            window.addEventListener('load', () => {
                if (window.location.hash.indexOf("/") >= 0) return;
                if (window.location.hash) {
                    scroll(window.location.hash);
                }
                if (window.location.search) {
                    if (window.location.search.indexOf("p=") > 0) {
                        const goto = window.location.search.substring(window.location.search.indexOf("p=") + 2)
                        scroll('#' + goto);
                    }
                }
            });
        }
        catch (err) { }
    }

    return {
        init: init
    }
})();

export default _scrollTo;